import classnames from "classnames";
import * as React from "react";
import { connect } from "react-redux";
import { isRequesting } from "src/requestProgress/helpers";
import { actions } from "src/requestProgress/reducer";
import { State } from "../../state";
import { formatMoneyValue } from "../../utils/formatters";
import { getHighlightedCellFn } from "../model/highlightedCells/selector";
import { AccountPresenterKind } from "../model/presenter/types";
import { selectCell as selectCellAction } from "../model/selectedCells/actions";
import { getCellSelectedFn } from "../model/selectedCells/selector";
import { getMappingNodeId } from "../model/spread/selector";

interface HiddenAccountCellBaseProps {
  account: AccountPresenterKind<"HIDDEN">;
  period: number;
}

interface HiddenAccountCellProps extends HiddenAccountCellBaseProps {
  isSelected: boolean;
  isHighlighted: boolean;
  selectCell: typeof selectCellAction;
  mappingNodeId: string | null;
  periodValue?: number;
  parentUserEditedValues?: boolean[];
}

export class HiddenAccountCell extends React.Component<HiddenAccountCellProps> {
  public valueClass = (
    account: AccountPresenterKind<"HIDDEN">,
    isSelected: boolean,
    isHighlighted: boolean,
    index: number
  ): string =>
    classnames(
      "AccountRow__value",
      "AccountRow__value--hidden",
      `AccountRow__value--period-${index + 1}`,
      {
        "AccountRow__value--selected": isSelected,
        "AccountRow__value--highlighted": isHighlighted,
        "AccountRow__value--disabled":
          this.props.parentUserEditedValues &&
          this.props.parentUserEditedValues[index]
      },
      "AccountRow__value--with-icon"
    );

  public onClick = (event: React.MouseEvent<HTMLTableCellElement>) => {
    event.stopPropagation();
    if (
      !isRequesting(actions.updateAccount) &&
      this.props.mappingNodeId === null
    ) {
      const period = this.props.period;
      const account = this.props.account;

      this.props.selectCell({
        period,
        account
      });
    }
  };

  public render() {
    return (
      <div
        className={this.valueClass(
          this.props.account,
          this.props.isSelected,
          this.props.isHighlighted,
          this.props.period
        )}
      >
        {this.props.children !== 0 && this.props.children}
        <div onClick={this.onClick}>
          {(this.props.periodValue || this.props.periodValue === 0) && (
            <span key={`${this.props.account.id}-value-${this.props.period}`}>
              {formatMoneyValue(this.props.periodValue)}
            </span>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (
  state: State,
  ownProps: HiddenAccountCellBaseProps
) => ({
  isSelected: getCellSelectedFn(state)(
    ownProps.account.spreadSheetType,
    ownProps.account.id,
    ownProps.period
  ),
  isHighlighted: getHighlightedCellFn(state)(
    ownProps.account.spreadSheetType,
    ownProps.account.id,
    ownProps.period
  ),
  mappingNodeId: getMappingNodeId(state)
});

export default connect(
  mapStateToProps,
  { selectCell: selectCellAction }
)(HiddenAccountCell);



// WEBPACK FOOTER //
// ./src/spread/chartOfAccounts/HiddenAccountCell.tsx